const LOCAL_STORAGE_NAMESPACE = {
    APP_DATA: 'appData'
};

export default LOCAL_STORAGE_NAMESPACE;
  